import { BRAND_NAME } from "../../config/constants";

const team = [
  {
    Name: "Jahaan",
    About:
      `Meet Jahaan, the youngest champion of Gift of Time. He is an intelligent and passionate champ who brings out-of-the-box ideas to the community. At just 14 years, he inspires everyone with his selfless and humble persona. Jahaan’s energy is contagious and his leadership is incredible. For his creativity, the sky's the limit! He conceptualised, designed and today leads the ${BRAND_NAME} Program and Trash Mafia, with Sanjana.`,
    image: `${process.env.REACT_APP_R2_URL}/jahaan.png`,
  },
  {
    Name: "Sanjana",
    About:
      `She came to Gift of Time as a young researcher during the course of which she opened our eyes to how the youth, who are full of promise, are not allowed to contribute to society. She has a talent of designing programs that know no age barrier! She conceptualised, created and designed the ${BRAND_NAME} Program and Trash Mafia, along with Jahaan.`,
    image: `${process.env.REACT_APP_R2_URL}/sanjana.png`,
  },
  {
    Name: "Ansh",
    About:
      "Ansh aged 17 going to Greenwood High and started the Library Cred$ program, collecting books from our community and creating libraries for 3 orphanages. Leading his project with discipline and helping everyone out when they can. ",
    image: `${process.env.REACT_APP_R2_URL}/ansh.png`,
  },

  {
    Name: "Sakshi",
    About:
      "Sakshi, aged 10 years old started a notebook collection drive along with the Library Cred$ drive to collect unused notebooks and donate them to children who did not have access to them. Eager to learn something new, Sakshi shows her interest while volunteering and initiating her project.",
    image: `${process.env.REACT_APP_R2_URL}/sakshi.png`,
  },

  {
    Name: "Devanshi",
    About:
      "Devanshi aged 12 started by making newspapers into bags and other items for the underprivileged as well as a collection of toys in our community from different houses that she wrapped and gifted to orphanages as a Christmas gift. Devanshi is hard-working and always signs up for anyone’s projects and doing great at them. ",
    image:
      `${process.env.REACT_APP_R2_URL}/devanshi.png`,
  },
  {
    Name: "Nirvaan",
    About:
      "Nirvaan started his rubix cube project to raise money and held classes for kids and adults, he is one of the main members of the speak-easy seniors’ program and even created the Time Cred$ logo we have today! Always smiling, he is here to have a good time and enjoys volunteering with his friends.",
    image: `${process.env.REACT_APP_R2_URL}/nirvaan.png`,
  },
  {
    Name: "Tarini Arora",
    About:
      "Tarini Arora, aged 9 started PiQture Me with her friend Mihika and have a vision to take pictures of 5000 orphans giving them a childhood memory to cherish forever. With her bubbly attitude she works with everyone to create an impact wherever she goes.",
    image:
      `${process.env.REACT_APP_R2_URL}/tarini_arora.png`,
  },
];

export default team;
